import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useState } from "react";
import card_top_img from "../../../assets/images/card_top-box.svg";
import { getBuyFilters, getBuySort } from "../../../utils/common";
import constant from "../../../utils/constants";
import Card from "./Card";
import DropDown from "./DropDown";
import { usePreview } from "../../../context/PreviewContextProvider";

const Buy = () => {
  
  const { data, previewCard } = usePreview();

  const filter = getBuyFilters(
    constant.priceFilter,
    data.filterData.artistBackground,
    data.filterData.pattern
  );

  const sort = getBuySort();

  //filter & sort state variables
  const [priceHeader, setPriceHeader] = useState("Price");
  const [isListOpen, setList] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(undefined);
  const [style, setStyle] = useState();
  const [styleType, setStyleType] = useState();
  const [filterType, setFilterType] = useState();
  const [boxDisplay, setBoxDisplay] = useState(false);
  const [owner, setOwner] = useState("");
  const [isInputOpen, setInputOpen] = useState(false);

  //cards state variable
  const [filteredCards, setFilteredCards] = useState(previewCard);
  const [currentPage, setPage] = useState(1);

  const placeholderCards = [
    {
      name: data.nft_name ? data.nft_name : "NFT", // If data.nft_name is not available, default to 'NFT'
      price: 0,
      image: card_top_img, // Image for placeholder cards
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: true,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    },
    {
      name: data.nft_name ? data.nft_name : "NFT",
      price: 0,
      image: card_top_img,
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: false,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    },
    {
      name: data.nft_name ? data.nft_name : "NFT",
      price: 0,
      image: card_top_img,
      tokenId: 1,
      siteTokenIndex: 1,
      forSale: false,
      originalPrice: 0,
      address: "0xB50041BCb2284A6f5Febec3EB82ebBc62471beaC",
    },
  ];

  const toggleList = (id) => {
    setFilterType(filter[id].key);
    setList(!isListOpen);
    setSelectedMenu(id);
    setInputOpen(false);
  };

  useEffect(() => {
    setList(true);
  }, [selectedMenu]);

  const paginationData = useMemo(() => {
    const filtered = filteredCards;
    const firstPageIndex = (currentPage - 1) * constant.CARDS_PER_PAGE;
    const lastPageIndex = firstPageIndex + constant.CARDS_PER_PAGE;
    return filtered.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredCards]);

  // Filter Dropdown options
  const filterDropdown = (item, menu) => {
    let fCards = [];
    switch (menu.key) {
      case "price":
        setPriceHeader(item.text);
        let priceString = item.text.split(" ");
        if (priceString[0] === "<") {
          fCards = previewCard.filter(
            (card) => Number(card.price) < Number(priceString[1])
          );
        } else if (priceString[0] === ">") {
          fCards = previewCard.filter(
            (card) => Number(card.price) > Number(priceString[1])
          );
        } else if (priceString[1] === "-") {
          fCards = previewCard.filter(
            (card) =>
              Number(card.price) >= Number(priceString[0]) &&
              Number(card.price) <= Number(priceString[2])
          );
        }
        break;
      case "bgcolor":
        setPriceHeader("Price");
        setBoxDisplay(true);
        setStyle(item.style);
        let bgcolor = item.style.backgroundColor;
        fCards = previewCard.filter((card) => card.bgColor === bgcolor);
        break;
      case "pattern":
        setPriceHeader("Price");
        setBoxDisplay(true);
        setStyle(item.style);
        let pattern = item.name;
        fCards = previewCard.filter((card) => card.pattern === pattern);
        break;
      default:
    }
    setStyleType(item.key);
    updateSelectedFilter(menu.id);
    setFilteredCards([...fCards]);
    setPage(1);
  };

  // Filter Owners
  const filterOwner = (value) => {
    let trimmedValue = value.trim();
    setPriceHeader("Price");
    setBoxDisplay(false);
    setOwner(trimmedValue);
    let fCards = previewCard.filter((card) =>
      card.address.includes(trimmedValue)
    );
    setFilteredCards([...fCards]);
  };

  const toggleInput = (id) => {
    setInputOpen(!isInputOpen);
    updateSelectedFilter(id);
    setList(false);
  };

  const resetfilters = () => {
    setPriceHeader("Price");
    setList(false);
    setBoxDisplay(false);
    setPage(1);
  };
  // Show all the nfts
  const filterViewAll = (id) => {
    resetfilters();
    updateSelectedFilter(id);
    setFilteredCards(previewCard);
  };

  // Update the selected button in filters
  const updateSelectedFilter = (id) => {
    let filterData = filter;
    filterData.map((i) => (i.selected = false));
    if (filterData[id]) filterData[id].selected = true;
  };

  // Update sort
  const sortFilter = (item) => {
    let fCards = [];
    if (item.sortType === "price") {
      if (item.direction === "up") {
        fCards = filteredCards.sort((a, b) => a.price - b.price);
      } else {
        fCards = filteredCards.sort((a, b) => b.price - a.price);
      }
    }
    if (item.sortType === "tnc") {
      if (item.direction === "up") {
        fCards = filteredCards.sort(
          (a, b) => a.pieData[2].value - b.pieData[2].value
        );
      } else {
        fCards = filteredCards.sort(
          (a, b) => b.pieData[2].value - a.pieData[2].value
        );
      }
    }
    sort.map((i) => (i.selected = false));
    sort[item.id].selected = true;
    setFilteredCards([...fCards]);
  };

  const renderCardData = () => {
    return (
      <>
        {previewCard.length === 0 ? (
          // Display placeholder cards if preview cards are unavailable
          <>
            {placeholderCards.map((card, index) => (
              <div className="nft-grid-card__wrapper" key={index}>
                <Card
                  card={card}
                  btn="Buy"
                  download={false}
                  overlay={false}
                  overlayText={false}
                />
              </div>
            ))}
          </>
        ) : (
          // Display actual preview cards if available
          <>
            {filteredCards.map((card) => (
              <div className="nft-grid-card__wrapper">
                <Card
                  card={card}
                  btn="Buy"
                  download={false}
                  overlay={false}
                  overlayText={false}
                />
              </div>
            ))}
          </>
        )}
      </>
    );
  };
  return (
    <section id="buy" className="page-settings">
      <h1
        className="page-title title-styles"
        style={{ color: data.web_main_color }}
      >
        {data.nft_name} for Sale
      </h1>
      <div className="filter-group">
        <div className="filter">
          <h3 className="filter__text" style={{ color: data.web_main_color }}>
            Filter by
          </h3>
          <div className="filter-grid">
            {filter.map((item, index) => (
              <div key={index} className="filter-item-grid">
                {item.filterType === "dropdown" ? (
                  <DropDown
                    menu={item}
                    header={item.key === "price" ? priceHeader : item.header}
                    bgStyle={style}
                    styleType={styleType}
                    filterType={filterType}
                    showBox={boxDisplay}
                    showList={isListOpen}
                    onUpdate={filterDropdown}
                    onToggle={toggleList}
                    styleData={data}
                  />
                ) : item.filterType === "textbox" ? (
                  <>
                    <button
                      className={`filter__btn ${item.selected ? "filter__btn--selected" : ""
                        }`}
                      style={{
                        borderColor: data.web_main_color,
                        color: data.web_main_color,
                      }}
                      onClick={() => toggleInput(item.id)}
                    >
                      Owner
                    </button>
                    <div
                      className={`owner-input__wrapper ${isInputOpen ? "d-block" : "d-none"
                        }`}
                    >
                      <input
                        name="owner"
                        className="owner-input"
                        value={owner}
                        onInput={(e) => filterOwner(e.target.value)}
                        placeholder="Type address"
                      ></input>
                    </div>
                  </>
                ) : item.filterType === "button" ? (
                  <button
                    className={`filter__btn ${item.selected ? "filter__btn--selected" : ""
                      }`}
                    style={
                      item.selected
                        ? {
                          backgroundColor: data.web_main_color,
                          color: "white",
                        }
                        : { color: data.web_main_color }
                    }
                    onClick={() => filterViewAll(item.id)}
                  >
                    View All
                  </button>
                ) : (
                  ""
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="filter">
          <h3 className="filter__text" style={{ color: data.web_main_color }}>
            Sort by
          </h3>
          <div className="filter-grid">
            {sort.map((item) => (
              <div key={item.id} className="filter-item-grid">
                <div
                  className={`sort__btn-wrapper ${item.selected ? "sort__btn--selected" : ""
                    }`}
                  style={
                    item.selected
                      ? { backgroundColor: data.web_main_color, color: "white" }
                      : {
                        color: data.web_main_color,
                        borderColor: data.web_main_color,
                      }
                  }
                  onClick={() => sortFilter(item)}
                >
                  <span
                    className="sort__btn-text"
                    style={{ color: data.web_main_color }}
                  >
                    {item.header}
                  </span>

                  <FontAwesomeIcon
                    icon={
                      item.direction === "up"
                        ? "fa-solid fa-arrow-up"
                        : "fa-solid fa-arrow-down"
                    }
                    color={data.web_main_color}
                    size="xl"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className="nft-cards buy-cards"
        style={{ justifyContent: paginationData.length < 4 ? "center" : "" }}
      >
        {renderCardData()}
      </div>
    </section>
  );
};

export default Buy;
